import { useCallback } from "react";
import useApiClient from "../services/axiosInstance";

export const useOTPService = () => {
  const { api } = useApiClient();
  const sendOTP = useCallback(
    async ({ payload }) => {
      try {
        const response = await api.post("/api/otp/send", payload);

        return response.data;
      } catch (error) {
        throw error; // need to return error like something went wrong do not throw here
      }
    },
    [api]
  );

  const verifyOTP = useCallback(
    async ({ data }) => {
      try {
        const response = await api.post("/api/otp/verify", data);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    [api]
  );
  return { sendOTP, verifyOTP };
};
